import { STOPPED, STOPPING } from '@shoflo/studio-redux/constants/StreamStates';
/**
 * Determines if the survey should be triggered based on stream endpoint status changes.
 *
 * @param {Array} previousEndpoints - Array of previous endpoint objects.
 * @param {Array} nextEndpoints - Array of next endpoint objects.
 * @returns {boolean} - True if the survey should be triggered, false otherwise.
 */
export const shouldTriggerSurvey = (previousEndpoints, nextEndpoints) => {
  // If there is only one stream, trigger the survey only when it has stopped
  if (nextEndpoints.length === 1) {
    return nextEndpoints[0].status === STOPPED;
  }

  // True if any previous endpoint is stopping and any next endpoint is stopped.
  const isStreamStopping = previousEndpoints.some(
    endpoint => endpoint.status === STOPPING
  );
  const isStreamAboutToBeStopped = nextEndpoints.some(
    endpoint => endpoint.status === STOPPED
  );
  return isStreamStopping && isStreamAboutToBeStopped;
};
